import * as React from 'react';
import {ReactNode} from 'react';
import style from './index.module.scss';


interface ITitleProps extends React.HTMLAttributes<HTMLDivElement> {
    toolbar?: ReactNode;
    options?: ReactNode;
    titleClassName?: string;
    optionsClassName?: string;
    toolbarClassName?: string;
}

export const Title = (props: ITitleProps) => {
    let {className, toolbar, options, titleClassName, optionsClassName, toolbarClassName, children} = props;
    return <div className={[style.titleWrapper, className].join(' ')}>
        <div className={style.titleContainer}>
            <div className={[style.title, titleClassName].join(' ')}>{children}</div>
            {options && <div className={optionsClassName}>{options}</div>}
        </div>
        {toolbar && <div className={[style.toolbar, toolbarClassName].join(' ')}>{toolbar}</div>}
    </div>;
};
